export default __webpack_public_path__ + "static/media/G0007.eaef1134.png";